import {
    faCameraRetro,
    faCube,
    faFilm,
    faMapMarkerAlt,
    faHome,
    faMap,
    faStreetView,
    faVideo,
    faAddressBook,
    faInfoCircle,
    faThLarge,
    faSave,

} from '@fortawesome/free-solid-svg-icons'

const getButtons = (baseUrl, buttonsParams, gallery, video, matterport, listingsCount) => {
    const getMatterPort = () => {
        if (matterport.matterport.length) {
            return matterport.matterport.map((m, i) => {
                let order = m.custom_content_type == 'id' ? parseInt(m.sort_order) + 1 : i + 1;
                let title = m.custom_content_type == 'id' && m.title ? m.title : '3D Walkthrough';
                return {
                    icon: faStreetView,
                    link: `${baseUrl}/matterport/${order}`,
                    visibility: buttonsParams.visibility.matterportBtnVisible,
                    default: buttonsParams.defaultButton === 'Matterport',
                    title: title,
                    defaultTitle: '3D Walkthrough',
                    headerLink: true,
                    openName: 'isMatterportOpenSubMenu'
                };
            })
        }
        return false;
    }

    const getVideo = () => {
        if (video.videos.length) {
            return video.videos.map((v, i) => {
                let order = v.custom_content_type == 'id' ? v.sort_order : i + 1;
                let title = v.custom_content_type == 'id' && v.title ? v.title : 'Video';
                return {
                    icon: faVideo,
                    link: `${baseUrl}/video/${order}`,
                    visibility: buttonsParams.visibility.videoBtnVisible,
                    default: buttonsParams.defaultButton === 'CustomVideo'
                        || buttonsParams.defaultButton === 'Video',
                    title: title,
                    defaultTitle: 'Video',
                    headerLink: true,
                    openName: 'isVideoOpenSubMenu'
                };
            })
        }
        return false;
    }
    const buttons = [
        {
            icon: faHome,
            link: `${baseUrl}`,
            visibility: true,
            default: buttonsParams.defaultButton === 'Dashboard',
            title: 'Dashboard',
            headerLink: false
        },
        {
            icon: faCameraRetro,
            link: `${baseUrl}/gallery`,
            visibility: gallery.galleryBtnVisible,
            default: buttonsParams.defaultButton === 'Photos',
            title: 'Photos',
            headerLink: true
        },
        {
            icon: faCube,
            link: `${baseUrl}/3d`,
            visibility: buttonsParams.visibility.threeDModelBtnVisible,
            default: false,
            title: buttonsParams.titles.threeDModelBtnTitle || '3D FloorPlan',
            headerLink: true
        },
        getMatterPort(),
        getVideo(),
        {
            icon: faMap,
            link: `${baseUrl}/floorplan`,
            visibility: buttonsParams.visibility.floorplanBtnVisible,
            default: buttonsParams.defaultButton === 'FloorPlan',
            title: 'Floor Plan',
            headerLink: true
        },
        {
            icon: faFilm,
            link: `${baseUrl}/walkthru`,
            visibility: buttonsParams.visibility.walkthruBtnVisible,
            default: buttonsParams.defaultButton === 'Walkthru',
            title: 'Walkthru',
            headerLink: true
        }
    ];

    buttons.push(...[
        {
            icon: faMapMarkerAlt,
            link: `${baseUrl}/map`,
            visibility: buttonsParams.visibility.mapBtnVisible,
            default: false,
            title: 'Location',
            headerLink: true

        },
        {
            icon: faInfoCircle,
            link: `${baseUrl}/about`,
            visibility: buttonsParams.visibility.infoBtnVisible,
            default: false,
            title: 'Property Details',
            headerLink: true
        },
        {
            icon: faAddressBook,
            link: `${baseUrl}/presented`,
            visibility: buttonsParams.visibility.pinfoBtnVisible,
            default: buttonsParams.defaultButton === 'Presented',
            title: 'Presented By',
            headerLink: true
        },
        {
            icon: faThLarge,
            link: `${baseUrl}/listings`,
            visibility: !!+listingsCount,
            default: false,
            title: 'More Listings',
            headerLink: true
        },
        {
            icon: faSave,
            link: buttonsParams.links.claimHomeBtnLink,
            visibility: !!buttonsParams.visibility.claimHomeBtnVisibility,
            default: false,
            title: 'Claim Home',
            external: true
        }
    ]);
    return buttons;
}

export default getButtons
